/**
 * Boost Box cart page — AJAX updates, recommendations, section refresh.
 */
(function ($) {
  'use strict';

  var qtyDebounce = null;

  function getRoot() {
    return $('.bb-cart[data-section-type="cart-page"]');
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatProductMoneyHtml) {
      return theme.Currency.formatProductMoneyHtml(cents, theme.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function productUrl(handle) {
    return (window.router || '') + '/products/' + handle;
  }

  function fetchRecommendations(productId, limit, intent) {
    return $.getJSON((window.router || '') + '/recommendations/products.json', {
      product_id: productId,
      limit: limit,
      intent: intent
    });
  }

  function getRecVariantId(product) {
    if (!product.variants || !product.variants.length) {
      return null;
    }
    var available = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) {
        available = product.variants[i];
        break;
      }
    }
    return (available || product.variants[0]).id;
  }

  function renderRecommendationCards($mount, products, $block) {
    if (!products.length) {
      $block.attr('hidden', true);
      $mount.empty();
      return;
    }

    var addLabel = $block.data('add-label') || 'Add to cart';
    var selectLabel = $block.data('select-label') || 'Select options';

    var html = products
      .map(function (p) {
        var img = p.featured_image || '';
        var price = formatMoney(p.price);
        var url = productUrl(p.handle);
        var multiVariant = p.variants && p.variants.length > 1;
        var variantId = getRecVariantId(p);
        var actionBtn = multiVariant
          ? '<a class="btn-move-cart bb-rec-cta" href="' + url + '">' + selectLabel + '</a>'
          : '<button type="button" class="btn-move-cart bb-rec-cta bb-rec-add" data-rec-add-to-cart data-variant-id="' + variantId + '" data-handle="' + p.handle + '">' + addLabel + '</button>';

        return (
          '<div class="bb-rec-card">' +
          '<a class="bb-rec-link" href="' + url + '">' +
          '<div class="bb-rec-thumb">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
          '</div>' +
          '<div class="bb-rec-body">' +
          (p.vendor ? '<div class="ci-brand">' + p.vendor + '</div>' : '') +
          '<div class="bb-rec-name">' + p.title + '</div>' +
          '<div class="saved-price">' + price + '</div>' +
          '</div>' +
          '</a>' +
          actionBtn +
          '</div>'
        );
      })
      .join('');

    $mount.html(html);
    $block.removeAttr('hidden');

    if (window.theme && theme.Currency && typeof theme.Currency.polishSarPriceDisplay === 'function') {
      theme.Currency.polishSarPriceDisplay($mount);
    }
  }

  function loadCartRecommendations($root) {
    var $block = $root.find('[data-cart-recommendations]');
    if (!$block.length) {
      return;
    }

    var productIds = String($block.data('product-ids') || '')
      .split(',')
      .filter(Boolean);
    var limit = parseInt($block.data('limit'), 10) || 4;
    var intent = $block.data('intent') || 'complementary';
    var $mount = $block.find('[data-cart-recs-mount]');
    var cartIds = productIds.map(function (id) {
      return parseInt(id, 10);
    });

    if (!productIds.length) {
      $block.attr('hidden', true);
      return;
    }

    var queryIds = productIds.slice(0, 3);
    var requests = queryIds.map(function (id) {
      return fetchRecommendations(id, limit, intent);
    });

    if (intent !== 'related') {
      requests.push(fetchRecommendations(productIds[0], limit, 'related'));
    }

    $.when
      .apply($, requests)
      .done(function () {
        var products = [];
        var seen = {};
        var args = arguments;
        var resultCount = requests.length;

        for (var i = 0; i < resultCount; i++) {
          var data = resultCount === 1 ? args : args[i][0];
          if (!data || !data.products) {
            continue;
          }
          data.products.forEach(function (p) {
            if (seen[p.id] || cartIds.indexOf(p.id) !== -1) {
              return;
            }
            seen[p.id] = true;
            products.push(p);
          });
        }

        renderRecommendationCards($mount, products.slice(0, limit), $block);
      })
      .fail(function () {
        $block.attr('hidden', true);
      });
  }

  function setItemLoading($item, loading) {
    if (!$item || !$item.length) return;
    $item.toggleClass('is-updating', !!loading);
  }

  function updateHeaderCartCount() {
    return $.getJSON('/cart.js').then(function (cart) {
      $('[data-cart-count]').text(cart.item_count);
      $('[data-cart-count-bubble]').text(cart.item_count);
      if (window.theme && theme.cart_dropdown && typeof theme.cart_dropdown.init === 'function') {
        theme.cart_dropdown.init();
      }
    });
  }

  function initShippingCalculator() {
    if (
      typeof Shopify === 'undefined' ||
      !Shopify.Cart ||
      !Shopify.Cart.ShippingCalculator ||
      !window.BBCartShippingCalculator
    ) {
      return;
    }
    if (!$('[data-shipping-calculator]').length) {
      return;
    }
    setTimeout(function () {
      Shopify.Cart.ShippingCalculator.show({
        submitButton: window.BBCartShippingCalculator.submitButton,
        submitButtonDisabled: window.BBCartShippingCalculator.submitButtonDisabled,
        customerIsLoggedIn: !!window.BBCartShippingCalculator.customerIsLoggedIn,
        moneyFormat: window.BBCartShippingCalculator.moneyFormat
      });
    }, 300);
  }

  function refreshSection() {
    var $root = getRoot();
    var sectionId = $root.attr('data-section-id');

    if (!sectionId) {
      window.location.reload();
      return $.Deferred().reject().promise();
    }

    return $.getJSON('/cart?sections=' + sectionId)
      .then(function (data) {
        var html = data[sectionId];
        if (!html) {
          window.location.reload();
          return;
        }
        var $new = $(html);
        $root.replaceWith($new);
        bindEvents(getRoot());
        initBankAccountAccordion(getRoot());
        loadCartRecommendations(getRoot());
        initShippingCalculator();
        return updateHeaderCartCount();
      })
      .fail(function () {
        window.location.reload();
      });
  }

  function changeLine(line, quantity) {
    return $.ajax({
      url: '/cart/change.js',
      method: 'POST',
      dataType: 'json',
      data: { line: line, quantity: quantity }
    });
  }

  function copyText(text) {
    if (!text) {
      return $.Deferred().reject().promise();
    }

    var deferred = $.Deferred();
    var $temp = $('<textarea readonly></textarea>').val(text).css({
      position: 'fixed',
      top: '0',
      left: '0',
      width: '1px',
      height: '1px',
      padding: 0,
      border: 'none',
      outline: 'none',
      opacity: 0
    });
    $('body').append($temp);
    var node = $temp[0];
    node.focus();
    node.select();
    if (typeof node.setSelectionRange === 'function') {
      node.setSelectionRange(0, text.length);
    }

    function finish(ok) {
      $temp.remove();
      if (ok) {
        deferred.resolve();
      } else {
        deferred.reject();
      }
    }

    try {
      finish(document.execCommand('copy'));
    } catch (err) {
      $temp.remove();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(deferred.resolve).fail(deferred.reject);
      } else {
        deferred.reject(err);
      }
    }

    return deferred.promise();
  }

  function decodeCopyValue(value) {
    return String(value || '')
      .replace(/&#10;/g, '\n')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"');
  }

  function getCopyValue($trigger) {
    var sourceId = $trigger.attr('data-copy-source-id');
    if (sourceId) {
      var $source = $('#' + sourceId);
      if ($source.length) {
        return $source.val() || $source.text();
      }
    }

    var attrValue = $trigger.attr('data-copy-value');
    if (attrValue) {
      return decodeCopyValue(attrValue);
    }

    var $value = $trigger.find('.bank-copy-value').first();
    if ($value.length) {
      return $.trim($value.text());
    }

    return '';
  }

  function runBankCopy($trigger) {
    var value = getCopyValue($trigger);
    if (!value) {
      return;
    }

    var $block = $trigger.closest('[data-bank-accounts]');

    copyText(value)
      .then(function () {
        $block.find('.bank-copy-row-btn.is-copied, .bank-copy-all-btn.is-copied').removeClass('is-copied');
        $trigger.addClass('is-copied');
        showBankCopyToast($block);
        setTimeout(function () {
          $trigger.removeClass('is-copied');
        }, 1800);
      })
      .fail(function () {
        var $fallback = $('<textarea readonly></textarea>')
          .val(value)
          .css({
            position: 'fixed',
            top: '20%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '90%',
            maxWidth: '360px',
            height: '120px',
            zIndex: 99999,
            padding: '12px',
            fontSize: '14px'
          });
        $('body').append($fallback);
        $fallback[0].focus();
        $fallback[0].select();
        window.setTimeout(function () {
          $fallback.remove();
        }, 8000);
      });
  }

  function showBankCopyToast($block) {
    var $toast = $block.find('[data-bank-copy-toast]');
    if (!$toast.length) {
      return;
    }
    $toast.removeAttr('hidden').addClass('is-visible');
    clearTimeout($toast.data('hideTimer'));
    $toast.data(
      'hideTimer',
      setTimeout(function () {
        $toast.attr('hidden', true).removeClass('is-visible');
      }, 2400)
    );
  }

  function setPaymentPreference(preference) {
    return $.ajax({
      url: '/cart/update.js',
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({
        attributes: {
          payment_preference: preference
        }
      })
    });
  }

  function goToCheckout() {
    window.location.href = '/checkout';
  }

  function bindEvents($root) {
    if (!$root.length) {
      return;
    }

    $root.off('.bbCart');

    $root.on('click.bbCart', '.bank-copy-row-btn, .bank-copy-all-btn', function (e) {
      e.preventDefault();
      e.stopPropagation();
      runBankCopy($(this));
    });

    $root.on('keydown.bbCart', '.bank-copy-row-btn, .bank-copy-all-btn', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        runBankCopy($(this));
      }
    });

    $root.on('click.bbCart', '[data-qty-minus]', function (e) {
      e.preventDefault();
      var $item = $(this).closest('[data-cart-item]');
      var $input = $item.find('[data-qty-input]');
      var line = $input.data('line');
      var val = parseInt($input.val(), 10) || 1;
      if (val <= 1) return;
      $input.val(val - 1);
      queueQtyChange($item, line, val - 1);
    });

    $root.on('click.bbCart', '[data-qty-plus]', function (e) {
      e.preventDefault();
      var $item = $(this).closest('[data-cart-item]');
      var $input = $item.find('[data-qty-input]');
      var line = $input.data('line');
      var val = parseInt($input.val(), 10) || 1;
      $input.val(val + 1);
      queueQtyChange($item, line, val + 1);
    });

    $root.on('change.bbCart', '[data-qty-input]', function () {
      var $input = $(this);
      var $item = $input.closest('[data-cart-item]');
      var line = $input.data('line');
      var val = parseInt($input.val(), 10);
      if (isNaN(val) || val < 1) {
        val = 1;
        $input.val(1);
      }
      queueQtyChange($item, line, val);
    });

    $root.on('click.bbCart', '[data-remove-item]', function (e) {
      e.preventDefault();
      var line = $(this).data('line');
      var $item = $(this).closest('[data-cart-item]');
      setItemLoading($item, true);
      changeLine(line, 0)
        .then(refreshSection)
        .fail(function () {
          window.location.reload();
        });
    });

    $root.on('click.bbCart', '[data-clear-cart]', function (e) {
      e.preventDefault();
      var msg = $root.attr('data-clear-confirm') || 'Remove all items from your cart?';
      if (!window.confirm(msg)) {
        return;
      }
      $.post('/cart/clear.js')
        .then(refreshSection)
        .fail(function () {
          window.location.reload();
        });
    });

    $root.on('click.bbCart', '[data-rec-add-to-cart]', function (e) {
      e.preventDefault();
      var $btn = $(this);
      var variantId = $btn.data('variant-id');
      var handle = $btn.data('handle');
      $btn.prop('disabled', true).addClass('is-loading');

      function addVariant(id) {
        return $.ajax({
          url: '/cart/add.js',
          method: 'POST',
          dataType: 'json',
          data: { id: id, quantity: 1 }
        });
      }

      var addPromise = variantId
        ? addVariant(variantId)
        : $.getJSON(productUrl(handle) + '.js').then(function (product) {
            return addVariant(getRecVariantId(product));
          });

      addPromise
        .then(refreshSection)
        .fail(function () {
          $btn.prop('disabled', false).removeClass('is-loading');
          if (handle) {
            window.location.href = productUrl(handle);
          }
        });
    });

    $root.on('click.bbCart', '[data-note-toggle]', function (e) {
      e.preventDefault();
      $(this).attr('hidden', true);
      $root.find('[data-note-field]').removeAttr('hidden');
      $root.find('[data-cart-note]').focus();
    });

    $root.on('blur.bbCart', '[data-cart-note]', function () {
      var note = $(this).val();
      $.ajax({
        url: '/cart/update.js',
        method: 'POST',
        dataType: 'json',
        data: { note: note }
      });
    });

    $root.on('click.bbCart', '[data-bank-checkout]', function (e) {
      e.preventDefault();
      var $btn = $(this);
      if ($btn.prop('disabled')) {
        return;
      }
      $btn.prop('disabled', true).addClass('is-loading');

      setPaymentPreference('bank_transfer')
        .always(goToCheckout);
    });

    $root.on('click.bbCart', '[data-online-checkout]', function (e) {
      e.preventDefault();
      var $btn = $(this);
      if ($btn.prop('disabled')) {
        return;
      }
      $btn.prop('disabled', true).addClass('is-loading');

      setPaymentPreference('online')
        .always(goToCheckout);
    });
  }

  function queueQtyChange($item, line, quantity) {
    clearTimeout(qtyDebounce);
    setItemLoading($item, true);
    qtyDebounce = setTimeout(function () {
      changeLine(line, quantity)
        .then(refreshSection)
        .fail(function () {
          window.location.reload();
        });
    }, 400);
  }

  function initBankAccountAccordion($root) {
    var $banks = $root.find('[data-bank-accounts] .bank-account-card');
    if (!$banks.length) {
      return;
    }

    $banks.off('toggle.bbBank').on('toggle.bbBank', function () {
      if (!this.open || window.innerWidth > 680) {
        return;
      }
      var self = this;
      $banks.each(function () {
        if (this !== self && this.open) {
          this.open = false;
        }
      });
    });
  }

  function clearStaleBankPreference($root) {
    var enabled = $root.attr('data-bank-transfer-enabled') === 'true';
    var pref = $root.attr('data-payment-preference') || '';
    if (!enabled && pref === 'bank_transfer') {
      return setPaymentPreference('').then(refreshSection);
    }
    return $.Deferred().resolve().promise();
  }

  function init() {
    var $root = getRoot();
    if (!$root.length) {
      return;
    }

    clearStaleBankPreference($root).always(function () {
      $root = getRoot();
      if (!$root.length) {
        return;
      }
      bindEvents($root);
      initBankAccountAccordion($root);
      loadCartRecommendations($root);
      initShippingCalculator();
    });
  }

  $(document).ready(init);

  $(document).on('shopify:section:load', function (evt) {
    if ($(evt.target).find('[data-section-type="cart-page"]').length) {
      init();
    }
  });
})(jQuery);
